import { render } from "./AttendeesPerEventDatePage.vue?vue&type=template&id=63aa7485"
import script from "./AttendeesPerEventDatePage.vue?vue&type=script&lang=js"
export * from "./AttendeesPerEventDatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__